import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';
import { environmentShared } from '../../../environments';
import { Processor } from '../../models';
import { AuthenticationService, DialogService, JobsService, ProcessorService } from '../../services';
import { UploaderModalComponent } from '../uploader-modal/uploader-modal.component';
import { Observable, Subscription } from 'rxjs';
import { JobUploaderService } from '../../services/standard/job-uploader.service';
import { DownloadService } from '../../services/standard/download.service';

@Component({
  selector: 'prism-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  env = environmentShared;
  localRefSelectedJob = null;
  allJobs$: Observable<any> = this.jobsService.jobs$;
  allJobsSub: Subscription;
  zipProcessing$ = this.downloadService.zipProcessing$;
  processor: Processor = null;

  constructor(private authService: AuthenticationService,
              private processorService: ProcessorService,
              private dialogService: DialogService,
              private downloadService: DownloadService,
              private jobsService: JobsService,
              private jobUploaderService: JobUploaderService) {
  }

  ngOnInit() {
    this.processorService.getProcessor()
      .pipe(
        first((processorResponse) => {
          const processor = processorResponse.data;
          return !!processor && !!processor.jobsCount;
        })
      )
      .subscribe(
        processorResponse => {
          this.processor = processorResponse.data;
        },
        error => {
          console.error('Cannot load processor:', error);
        });

    this.allJobsSub = this.allJobs$.subscribe(
      jobs => {
        if (jobs !== null) {
          this.setSelectedUploaderJob(jobs[0]);
          this.localRefSelectedJob = jobs[0];
        }
      },
      err => console.error(err),
      () => this.allJobsSub.unsubscribe()
    );
  }

  setSelectedUploaderJob(job) {
    this.localRefSelectedJob = job;
    this.jobUploaderService.setSelectedUploaderJob(job);
  }

  onLogout() {
    this.authService.logout();
  }

  openUploaderModal() {
    this.dialogService.openDialog(UploaderModalComponent, {
      jobsCount: this.processor.jobsCount,
      serviceType: Object.keys(this.processor.skills)[0]
    }, {height: '90vh', panelClass: 'base-modal-dialog'});
  }
}
